import get from 'utils/request/get';
import logError from 'utils/extra/logError';
import { formatAndStoreMasterData } from 'utils/methods/masterData';

export default function getMasterData(
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {},
) {
  return get('/retailer/masterData/', { isPublic: true })
    .then(({ data }) => {
      if (!data) {
        throw new Error('Failed to fetch the master data');
      }
      const { masterData, normalisedMasterData } =
        formatAndStoreMasterData(data);
      if (!normalisedMasterData) {
        throw new Error('Failed to format the masterData');
      }
      onSuccess(masterData, normalisedMasterData);
    })
    .catch((err) => {
      logError(err || new Error('Error in loading master data'));
      onError(err);
    })
    .finally(onFinally);
}
